/* ==========================================================================
   Ryse - Theoric: o submenu do celular

   Duas coisas aqui: o nome da categoria ABRE o submenu (nao navega), e o botao
   "Ver tudo em ..." e montado a partir dos dados do proprio tema.

   ==========================================================================
   1) O NOME ABRE O SUBMENU, NAO A PAGINA
   Romulo, 12/07/2026: "quando clico no nome do submenu, nao quero que abra a
   pagina dele."

   Cada linha do menu tem DOIS alvos, um do lado do outro:

     <a  class="mobile-megamenu__link--nav" href="/collections/...">Celebre</a>
     <button data-menu-expand data-link-title="Celebre" data-link-url="...">+</button>

   Ou seja: o texto levava para a colecao, e so o "+" abria o submenu. No celular,
   isso e uma armadilha - o alvo grande (o nome, com toda a largura da linha) faz a
   coisa MENOS provavel, e o alvo pequeno (o "+", 40px no canto) faz a mais
   provavel. Quem toca no nome quer VER o que tem ali dentro; quem quer a pagina
   inteira tem o "Ver tudo em ...", no fim do submenu.

   Entao o nome passa a fazer o mesmo que o "+": abre o submenu. O <a> continua
   sendo um <a> (com href, para leitor de tela, toque longo e "abrir em nova aba") -
   so o clique comum e desviado.

   >>> SO ONDE HA SUBMENU. <<<
   Uma linha sem botao de expandir (uma categoria folha, sem filhos) continua
   navegando normalmente: nao existe submenu para abrir.

   ==========================================================================
   2) O BOTAO "VER TUDO EM ..."
   O tema ja sabe para onde a categoria vai - so nao mostra: os data-* do botao de
   expandir trazem o titulo e a URL. Entao nao ha nada a adivinhar nem a chumbar. Se
   amanha entrarem categorias novas, ou as URLs mudarem no admin, isto continua
   certo sem ninguem tocar aqui.

   >>> POR QUE UM <a> E NAO UM <button> <<<
   E navegacao, nao acao: precisa abrir em nova aba com toque longo, entrar no
   historico e ser lido como link. Um <button> com JS por cima perde as tres coisas.

   Carregado por snippets/theoric-cart-motion-load.liquid.
   ========================================================================== */
(function () {
  var LIMITE_MOBILE = 989;

  var secao = document.getElementById('SidePopupMenu');
  if (!secao) return;

  var submenu = secao.querySelector('.mobile-megamenu__state--detail');

  var titulo = '';
  var url = '';

  /* ------------------------------------------------------------- o botao */
  function montar() {
    if (!submenu) return;
    if (window.innerWidth > LIMITE_MOBILE) return;
    if (!url) return;

    var botao = submenu.querySelector('.theoric-menu-vertudo');

    if (!botao) {
      botao = document.createElement('a');
      botao.className = 'theoric-menu-vertudo';
      /* por ultimo, FORA do .detail-content: e assim que ele fica fixo enquanto o
         carrossel rola. Ver o CSS. */
      submenu.appendChild(botao);
    }

    botao.setAttribute('href', url);
    botao.textContent = titulo ? 'Ver tudo em ' + titulo : 'Ver tudo';
  }

  function guardar(expandir) {
    titulo = expandir.getAttribute('data-link-title') || '';
    url = expandir.getAttribute('data-link-url') || '';
    montar();
  }

  secao.addEventListener(
    'click',
    function (evento) {
      var alvo = evento.target;
      if (!(alvo instanceof Element)) return;

      /* (a) tocou no "+" - o caminho normal do tema */
      var expandir = alvo.closest('[data-menu-expand]');
      if (expandir) {
        guardar(expandir);
        return;
      }

      if (window.innerWidth > LIMITE_MOBILE) return;

      /* (b) tocou no NOME da categoria: abre o submenu em vez de navegar */
      var nome = alvo.closest('.mobile-megamenu__link--nav');
      if (!nome) return;

      var linha = nome.closest('.mobile-megamenu__link-row');
      var botaoExpandir = linha && linha.querySelector('[data-menu-expand]');

      /* sem submenu para abrir, o link faz o que sempre fez */
      if (!botaoExpandir) return;

      evento.preventDefault();
      guardar(botaoExpandir);
      botaoExpandir.click();   /* deixa o tema abrir o submenu do jeito dele */
    },
    /* CAPTURA: o clique precisa ser interceptado ANTES de o navegador seguir o
       href. Na fase de bolha ja seria tarde em alguns navegadores. */
    true
  );

  /* rede de seguranca: se o tema abrir o submenu por outro caminho (teclado, deep
     link), o botao ainda aparece - desde que ja haja um link guardado. */
  if (submenu) {
    new MutationObserver(function () {
      if (submenu.classList.contains('is-active')) montar();
    }).observe(submenu, { attributes: true, attributeFilter: ['class'] });
  }
})();
